import { BaseRoute } from 'component/RouteWithSubRoutes';
import APP_ROUTE from 'constant/route';
import Home from './Home';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import Booking from './Booking';
import Switch from './Switch';
import None from './None';
import Details from './Details';
import NotFound from './NotFound';
import Invited from './Invited';
import MeetingSchedule from './MeetingSchedule';
import Edit from './Edit';
import Contact from './Contact';
import { lazy } from 'react';
import RoomDetail from './RoomDetail';
import OrderMeeting from './OrderMeeting';
import FeedBack from './Feedback';
import WorkWeChatLogin from '../sub-login/workWeChatLogin';
import EarlyEnd from './EarlyEnd';

const routes: BaseRoute[] = [
  {
    path: APP_ROUTE.LOGIN,
    component: Login,
    exact: true
  },
  {
    path: APP_ROUTE.TRANSFER,
    component: lazy(() => import('./Transfer')),
    exact: true
  },
  {
    path: APP_ROUTE.FORGOT_PASSWORD,
    component: ForgotPassword,
    exact: true
  },
  {
    path: APP_ROUTE.SWICH,
    component: Switch,
    exact: true
  },
  {
    path: APP_ROUTE.NONE,
    component: None,
    exact: true
  },
  {
    path: APP_ROUTE.WorkWeChatLOGIN,
    component: WorkWeChatLogin,
    exact: true,
    auth: true
  },
  // 首页放在最后面，防止路由匹配冲突
  {
    path: APP_ROUTE.INDEX,
    component: Home,
    exact: false,
    routes: [
      {
        path: APP_ROUTE.SCHEDULE,
        component: MeetingSchedule,
        exact: true
      },
      {
        path: APP_ROUTE.ROOM_DETAIL,
        component: RoomDetail,
        exact: true
      },
      {
        path: APP_ROUTE.CONTACT,
        component: Contact,
        exact: true
      },
      {
        path: APP_ROUTE.DETAILS,
        component: Details,
        exact: true
      },
      {
        path: APP_ROUTE.ORDER_MEETING,
        component: OrderMeeting,
        exact: true
      },
      {
        path: APP_ROUTE.EDIT,
        component: Edit,
        exact: true
      },
      {
        path: APP_ROUTE.INVITED,
        component: Invited,
        exact: true
      },
      {
        path: APP_ROUTE.EARLY_END,
        component: EarlyEnd,
        exact: true
      },
      {
        path: APP_ROUTE.HOME,
        component: Booking,
        exact: true
      },
      {
        path: APP_ROUTE.HELP,
        component: FeedBack,
        keepAlive: true,
        exact: true
      },
      {
        path: APP_ROUTE.APPROVALCENTER,
        component: lazy(() => import('./ApprovalCenter')),
        exact: true,
        auth: true
      },
      {
        path: APP_ROUTE.INITIATEDAPPROVALDETAIL,
        component: lazy(() => import('./ApprovalCenter/InitiatedPage')),
        exact: true,
        auth: true
      },
      {
        path: APP_ROUTE.RECEIVEDAPPROVALDETAIL,
        component: lazy(() => import('./ApprovalCenter/ReceivedPage')),
        exact: true,
        auth: true
      },
      {
        path: '*',
        component: NotFound
      }
    ]
  },
  {
    path: '*',
    component: NotFound
  }
];

export default routes;
